import { type Comment as CommentType } from '@entities/common/Comments/comments';
import { useMemo } from 'react';
import { Comment, type CommentPT } from '@features/common/Comments/Comment/index.tsx';
import { NewCommentButton } from '@features/common/Comments/NewCommentButton/index.tsx';
import { PageBackButton } from '@features/common/PageBackButton/index.tsx';
import { useUser } from '@shared/hooks/index.ts';
import { ListBody, PageHead } from '@shared/ui/index.ts';
import * as st from './styles.module.scss';

type CommentListPT = Pick<CommentPT, 'isContentAuthor' | 'article' | 'program'> & {
  comments: CommentType[];
  isPaid?: boolean;
};

export const CommentsList = ({
  comments,
  program,
  article,
  isContentAuthor,
  isPaid = true,
}: CommentListPT) => {
  const { user } = useUser();

  const myCommentId = useMemo(() => {
    const myComment = comments.find((com) => com.user.id === user?.id);
    return myComment?.id;
  }, [user, comments]);

  return (
    <>
      <PageHead
        Center={'Отзывы'}
        Left={<PageBackButton />}
        Right={
          isContentAuthor || !isPaid ? undefined : (
            <NewCommentButton
              linkValue={myCommentId ? `${myCommentId}` : undefined}
              article={article}
              program={program}
            />
          )
        }
      />
      <ListBody className={st.list}>
        {comments.map((comment) => (
          <Comment
            key={comment.id}
            isContentAuthor={isContentAuthor}
            article={article}
            program={program}
            {...comment}
          />
        ))}
      </ListBody>
    </>
  );
};
